import * as React from "react";
import { Navigate } from "react-router";
import { useIsAuthenticated } from "@refinedev/core";

interface AuthGuardProps {
  children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps): React.JSX.Element {
  const { data, isLoading } = useIsAuthenticated();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[var(--bg)]">
        <div
          className="w-8 h-8 border-2 border-[var(--accent)] border-t-transparent rounded-full animate-spin"
          role="status"
          aria-label="Проверка авторизации"
        />
      </div>
    );
  }

  if (!data?.authenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
